import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../Field'
import { FormFieldSelectNG } from '../../Form'
import { FormikField } from '../../Formik'
import { ButtonSelect } from '../../Select'
import { DOC_FLOW_FORM_FIELD_TYPE } from '../DocFlow.constants'
import { getDocFlowMappingTypeOptions } from '../DocFlow.utils.mapping'

function DocFlowEditTypeFields(props) {
  const { t } = useTranslation()

  const options = getDocFlowMappingTypeOptions(t)

  return (
    <FormikField
      {...props}
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={ButtonSelect}
      controlProps={{
        indicatorsProps: {
          ButtonClear: null,
        },
      }}
      fieldComponentProps={{
        label: t('DocumentStapling.EditTypeFieldLabelKey'),
        required: true,
      }}
      name={DOC_FLOW_FORM_FIELD_TYPE}
      options={options}
    />
  )
}

export default DocFlowEditTypeFields
